export default __webpack_public_path__ + "static/media/pm.50eba2e6.jpg";